// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1884":"css/app.6896","9523":"css/admin-app.6896"}[chunkId] + ".css";
};